const module_class_name = '.guide-slides';
const selector = module_class_name + ' .glide';

if(document.querySelector(selector)) {
  let glide = new Glide(selector, {
    perView: 1,
    autoheight: true
  }).mount();

  console.log(document.querySelectorAll(selector).length);
}
